import { RoutePermittedRole } from "shared/constants/AppConst";
import Cms from "./cms_page";
import CmsUpdateIndex from "./cms_page/CmsPageUpdate";
import CmsCreateIndex from "./cms_page/CmsPageCreate";
import { isModuleAuthorized } from "@crema/utility/Utils";
import Error403 from "pages/errorPages/Error403";

export const cmsMasterConfig = [
  {
    permittedRole: RoutePermittedRole.User,
    path: "/pages/CmsPageCreate",
    exact: true,
    element: isModuleAuthorized("Add CMS") ? <CmsCreateIndex /> : <Error403 />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/pages/:pageID",
    exact: true,
    element: isModuleAuthorized("Edit CMS") ? <CmsUpdateIndex /> : <Error403 />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/pages",
    exact: true,
    element: isModuleAuthorized("Manage Cms Page") ? <Cms /> : <Error403 />,
  },
];
